export default "__VITE_ASSET__BIlxrqLd__"